<!-- Header -->
<div class="modal-header" mat-dialog-title>
  <div class="modal-header-titles modal-header-titles--barra">
    <h2 class="modal-title">Nova solicitação de compra</h2>
    <span class="modal-subtitle">Solicitação de Compra — o card entrará nesta etapa e seguirá o fluxo do Kanban</span>
  </div>
  <div class="modal-header-close-btn-container">
    <button mat-icon-button type="button" class="modal-close-btn" [disabled]="saving" (click)="fechar()" aria-label="Fechar">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="modal-content">

  <!-- TÍTULO -->
  <div class="row g-3">
    <div class="col-12">
      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
        <mat-label>Título</mat-label>
        <input matInput [(ngModel)]="titulo" placeholder="Ex.: Materiais para o novo escritório" maxlength="255" />
      </mat-form-field>
    </div>
  </div>

  <!-- ITENS -->
  <div class="section-container">
    <div class="section-title">
      <mat-icon>inventory_2</mat-icon>
      <span>Itens</span>
      @if (items.length) {
        <span class="status-badge badge-cinza">{{ items.length }}</span>
      }
      <div class="section-title-actions ms-auto">
        @if (!itemAdding) {
          <button mat-button type="button" class="btn-section" (click)="toggleAddingItem()">
            <mat-icon>add</mat-icon>
            Adicionar item
          </button>
        } @else {
          <button mat-button type="button" class="btn-section btn-section--cancel" (click)="toggleAddingItem()">
            <mat-icon>close</mat-icon>
            Cancelar
          </button>
        }
      </div>
    </div>

    <!-- Mesmo painel do "Adicionar item" das etapas do card. -->
    @if (itemAdding) {
      <div class="ced-cot-add">
        <div class="ced-cot-add__head">
          <mat-icon class="material-symbols-outlined">{{ avulsoMode ? 'edit_note' : 'add_shopping_cart' }}</mat-icon>
          <span>{{ avulsoMode ? 'Adicionar produto avulso' : 'Adicionar item' }}</span>
          <span class="ced-section-spacer"></span>
          <button type="button" class="ced-cot-add__close" (click)="toggleAddingItem()" matTooltip="Fechar">
            <mat-icon class="material-symbols-outlined">close</mat-icon>
          </button>
        </div>
        <div class="ced-cot-add__body">
          @if (!avulsoMode) {
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
              <mat-label>Buscar produto</mat-label>
              <mat-icon matIconPrefix>search</mat-icon>
              <input
                #buscaProdutoInput
                matInput
                type="text"
                placeholder="Nome ou SKU do produto…"
                [(ngModel)]="searchQuery"
                (ngModelChange)="onSearchChange()"
                [matAutocomplete]="auto" />
              <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayProduto" (optionSelected)="addItem($event.option.value)">
                @for (p of results; track p.idProduto) {
                  <mat-option [value]="p">
                    <span>{{ p.name }}</span>
                    <span class="small text-muted">
                      @if (p.sku) { · SKU {{ p.sku }} } · estoque {{ p.stock }} {{ p.unit }}
                    </span>
                  </mat-option>
                }
                @if (!searching && results.length === 0 && searchQuery) {
                  <mat-option disabled>Nenhum produto encontrado.</mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
            <div class="add-rodape">
              <div class="ced-cot-add__hint">
                <mat-icon class="material-symbols-outlined">info</mat-icon>
                Não encontrou no cadastro? Adicione como avulso; ele precisa ser vinculado ao cadastro antes do Pedido.
              </div>
              <button mat-button type="button" class="btn-section" (click)="startAvulso()">
                <mat-icon>edit_note</mat-icon>
                Adicionar como avulso
              </button>
            </div>
          } @else {
            <div class="avulso-grid">
              <mat-form-field appearance="outline" subscriptSizing="dynamic" class="avulso-desc">
                <mat-label>Descrição do produto</mat-label>
                <input #avulsoDescInput matInput [(ngModel)]="avulsoName" placeholder="Ex.: Cadeira ergonômica modelo X"
                  (keydown.enter)="confirmAvulso()" />
              </mat-form-field>
              <mat-form-field appearance="outline" subscriptSizing="dynamic">
                <mat-label>Unidade</mat-label>
                <mat-select [(ngModel)]="avulsoUnit">
                  @for (u of unitOpts; track u.value) {
                    <mat-option [value]="u.value">{{ u.label }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline" subscriptSizing="dynamic" class="avulso-obs">
                <mat-label>Observação (opcional)</mat-label>
                <input matInput [(ngModel)]="avulsoNote" placeholder="Modelo, fornecedor sugerido, link…"
                  (keydown.enter)="confirmAvulso()" />
              </mat-form-field>
            </div>
            <div class="avulso-actions">
              <button mat-stroked-button type="button" class="btn-secondary" (click)="cancelAvulso()">
                <mat-icon>arrow_back</mat-icon>
                Voltar à busca
              </button>
              <button mat-flat-button type="button" class="btn-primary" [disabled]="!avulsoValid" (click)="confirmAvulso()">
                <mat-icon>add</mat-icon>
                Adicionar
              </button>
            </div>
          }
        </div>
      </div>
    }

    <!-- Lista de itens -->
    @if (items.length === 0 && !itemAdding) {
      <app-empty-state
        icon="inventory_2"
        title="Nenhum item adicionado."
        subtitle="Use “Adicionar item” para incluir produtos do cadastro ou um produto avulso.">
      </app-empty-state>
    } @else if (items.length > 0) {
      <div class="table-responsive mt-2">
        <table mat-table [dataSource]="items" class="w-100">

          <!-- Item -->
          <ng-container matColumnDef="item">
            <th mat-header-cell *matHeaderCellDef>Item</th>
            <td mat-cell *matCellDef="let item">
              <span>{{ item.name }}</span>
              @if (item.avulso) {
                <span class="status-badge badge-cinza item-badge" matTooltip="Produto não cadastrado no estoque">Avulso</span>
              }
              <div class="small text-muted">
                @if (item.avulso) {
                  Produto não cadastrado@if (item.note) { · {{ item.note }} }
                } @else {
                  @if (item.sku) { SKU {{ item.sku }} · } estoque {{ item.stock }} {{ item.unit }}
                }
              </div>
            </td>
          </ng-container>

          <!-- Quantidade -->
          <ng-container matColumnDef="quantidade">
            <th mat-header-cell *matHeaderCellDef class="text-center" style="width: 130px">Quantidade</th>
            <td mat-cell *matCellDef="let item" class="text-center quantity-cell">
              <mat-form-field appearance="outline" class="quantity-field" subscriptSizing="dynamic">
                <input matInput [currencyMask]="quantidadeMask" [(ngModel)]="item.qty" />
              </mat-form-field>
            </td>
          </ng-container>

          <!-- Unidade -->
          <ng-container matColumnDef="unidade">
            <th mat-header-cell *matHeaderCellDef style="width: 110px">Unidade</th>
            <td mat-cell *matCellDef="let item">{{ item.unit }}</td>
          </ng-container>

          <!-- Ações -->
          <ng-container matColumnDef="acoes">
            <th mat-header-cell *matHeaderCellDef class="text-center w-actions">Ações</th>
            <td mat-cell *matCellDef="let item; let i = index" class="text-center w-actions">
              <button mat-icon-button type="button" matTooltip="Remover item" (click)="removeItem(i)">
                <mat-icon class="material-symbols-outlined">delete</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
    }
  </div>

  <!-- DETALHES -->
  <div class="section-container">
    <div class="section-title">
      <mat-icon>tune</mat-icon>
      <span>Detalhes</span>
    </div>

    <div class="row g-3">
      <div class="col-12 col-md-6">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
          <mat-label>Setor</mat-label>
          <input matInput [(ngModel)]="setor" placeholder="Ex.: TI, Administrativo…" maxlength="120" />
        </mat-form-field>
      </div>

      <div class="col-12 col-md-6">
        <app-select-pesquisavel
          [control]="responsavelControl"
          [offlineList]="people"
          [preloadedOptions]="people"
          [idField]="'idUsuario'"
          [nameField]="'name'"
          [avatarTextField]="'initials'"
          [avatarColorField]="'color'"
          [label]="'Responsável'"
          subscriptSizing="dynamic">
        </app-select-pesquisavel>
      </div>

      <div class="col-12 col-md-6">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
          <mat-label>Prioridade</mat-label>
          <mat-select [(ngModel)]="prio" required>
            <mat-select-trigger>
              <span class="prio-dot" [style.background]="getPrioColor(prio)"></span>
              {{ getPrioLabel(prio) }}
            </mat-select-trigger>
            @for (o of prioOpts; track o.key) {
              <mat-option [value]="o.key">
                <span class="prio-dot" [style.background]="o.color"></span>
                {{ o.label }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-12 col-md-6">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
          <mat-label>Entrega desejada</mat-label>
          <input matInput [matDatepicker]="picker" [(ngModel)]="date" (input)="onDateInput($event)" placeholder="DD/MM/AAAA" />
          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="col-12">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
          <mat-label>Justificativa</mat-label>
          <textarea matInput rows="3" [(ngModel)]="justification"
            placeholder="Descreva a motivação da compra (opcional)…"></textarea>
        </mat-form-field>
      </div>
    </div>
  </div>

</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions class="modal-footer">
  <button mat-stroked-button type="button" class="btn-secondary" [disabled]="saving" (click)="fechar()">Cancelar</button>
  <span [matTooltip]="motivoCriarDesabilitado" [matTooltipDisabled]="valid">
    <button mat-flat-button type="button" class="btn-primary btn-spinner" [class.btn-loading]="saving"
      [disabled]="!valid || saving" (click)="criar()"
      [attr.aria-label]="saving ? 'Criando solicitação' : 'Criar solicitação'">
      Criar solicitação
      @if (saving) { <mat-spinner diameter="20"></mat-spinner> }
    </button>
  </span>
</mat-dialog-actions>
